var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 12.5C26.75 21.25 15.5 28.75 15.5 28.75C15.5 28.75 4.25 21.25 4.25 12.5C4.25 9.51631 5.43526 6.65483 7.54505 4.54505C9.65483 2.43526 12.5163 1.25 15.5 1.25C18.4837 1.25 21.3452 2.43526 23.455 4.54505C25.5647 6.65483 26.75 9.51631 26.75 12.5Z",
    stroke: "#FF7F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.25C17.5711 16.25 19.25 14.5711 19.25 12.5C19.25 10.4289 17.5711 8.75 15.5 8.75C13.4289 8.75 11.75 10.4289 11.75 12.5C11.75 14.5711 13.4289 16.25 15.5 16.25Z",
    stroke: "#FF7F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeMapPin);
export default __webpack_public_path__ + "static/media/orange-map-pin.42207e5e8c69feb12951b8569633128e.svg";
export { ForwardRef as ReactComponent };